import { DEFAULT_MERCHANT_TIMEZONE } from "@redotech/redo-common-model/timezone-list";

export interface InboundEta {
  text: string;
  overdue: boolean;
}

/**
 * An inbound shipment is overdue once its ETA (YYYY-MM-DD) is before today in
 * the team's time zone. Without one, use the server's default, not the
 * browser's.
 */
export function getInboundEta(
  eta: string,
  { now, timeZone }: { now: Temporal.Instant; timeZone: string | undefined },
): InboundEta | undefined {
  let date: Temporal.PlainDate;
  try {
    date = Temporal.PlainDate.from(eta);
  } catch {
    return undefined;
  }
  const today = now
    .toZonedDateTimeISO(timeZone ?? DEFAULT_MERCHANT_TIMEZONE)
    .toPlainDate();
  return {
    text: `ETA ${date.toLocaleString(undefined, { month: "short", day: "numeric" })}`,
    overdue: Temporal.PlainDate.compare(date, today) < 0,
  };
}
